import * as React from 'react';
import AccountDetailHeader from '../Admin/Accounts/AccountDetailHeader';
import { SponsorAccountList } from '../Admin/Accounts/SponsorAccountList';
import System from 'src/helper/system';
import AdminConsoleHeader from '../Admin/AdminConsoleHeader';

const c = System.getParams();

const AccountDetail = () => {
  const { translation:t } = System;
  return (
    <>
      <div className='adminconsole-container'>
        <AdminConsoleHeader title={t('ACCOUNTDETAILS')} />

        <AccountDetailHeader accountDetails={c} />

        <SponsorAccountList accountDetails={c} />
      </div>
    </>
  );
}

export default AccountDetail;